import { render, staticRenderFns } from "./ProjetoValidacao.vue?vue&type=template&id=8ef24b3c&scoped=true&"
import script from "./ProjetoValidacao.vue?vue&type=script&lang=js&"
export * from "./ProjetoValidacao.vue?vue&type=script&lang=js&"
import style0 from "./ProjetoValidacao.vue?vue&type=style&index=0&id=8ef24b3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef24b3c",
  null
  
)

export default component.exports